<template>
  <div
    class="slide-bar"
    :class="{ 'slide-bar-full': displayMenuName }"
    @mouseover="displayMenuName = true"
    @mouseleave="
      displayMenuName = false;
      displayUserMenu = false;
    "
  >
    <div class="user-menu" v-if="displayUserMenu && displayMenuName">
      <ul>
        <li disabled class="user-menu-item">User Information</li>
        <li disabled class="user-menu-item">Change Password</li>
        <li class="user-menu-item" @click="confirmation">Logout</li>
      </ul>
    </div>
    <div class="Nav-container" :class="{ 'slide-bar-full': displayMenuName }">
      <div class="reset-style Nav-Org-layout">
        <div class="Nav-Org-logo">
          <img width="48" height="48" src="../../assets/v3/imgs/Org_logo.png" />
        </div>
        <div v-if="displayMenuName" class="Nav-Org-text">
          {{ organizationName }}
        </div>
      </div>
      <div class="Nav-Bar">
        <ul>
          <li @click="$bvModal.show('Notifications-modal')"><div
                class="Nav-item"
                :class="{ 'user-info-full': displayMenuName }"
              >
                <b-icon
                  icon="bell-fill" scale="1.5"
                  variant="light" class="icon-bell-notify"
                  ></b-icon
                >
                <div v-if="displayMenuName" class="Nav-Menu-text">
                  Notifications
                </div>
                <b-badge pill variant="danger" v-if="notifyCount > 0" class="badge-notify"
                    >{{ notifyCount }}</b-badge
                  >
              </div>
          </li>
          <li>
            <router-link href="" to="/"
              ><div
                class="Nav-item"
                :class="{ 'user-info-full': displayMenuName }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21.3445 5.09974L16.9006 3.09999H15.9896L12.0012 4.88866L8.01282 3.09999H7.95727L7.82395 3H7.15736L2.71346 4.99976C2.49181 5.08469 2.30319 5.23838 2.17523 5.43831C2.04728 5.63823 1.98672 5.87389 2.00244 6.11073V19.6646C2.00275 19.8505 2.0497 20.0334 2.13898 20.1964C2.22826 20.3594 2.35703 20.4975 2.51349 20.5979C2.6923 20.7134 2.90054 20.7751 3.11341 20.7756C3.27061 20.7749 3.42586 20.7408 3.56891 20.6756L7.55732 18.887L11.5457 20.6756H11.6013C11.7265 20.7342 11.863 20.7645 12.0012 20.7645C12.1394 20.7645 12.276 20.7342 12.4012 20.6756H12.4567L16.4451 18.887L20.4335 20.6756C20.5766 20.7408 20.7318 20.7749 20.889 20.7756C21.1019 20.7751 21.3101 20.7134 21.489 20.5979C21.6454 20.4975 21.7742 20.3594 21.8635 20.1964C21.9527 20.0334 21.9997 19.8505 22 19.6646V6.11073C21.9996 5.89702 21.9375 5.68798 21.8212 5.50866C21.705 5.32934 21.5394 5.18736 21.3445 5.09974ZM8.66829 5.83299L10.8902 6.82176V17.9315L8.66829 16.9427V5.83299ZM19.778 17.9426L17.5561 16.9539V5.8441L19.778 6.83287V17.9426Z"
                    fill="#ECECEF"
                  />
                </svg>
                <div v-if="displayMenuName" class="Nav-Menu-text">
                  Dashboard
                </div>
              </div></router-link
            >
          </li>
          <li>
            <router-link href="" to="/siteoper"
              ><div
                class="Nav-item"
                :class="{ 'user-info-full': displayMenuName }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M2 11.1111C2 12.2157 2.89543 13.1111 4 13.1111H8.88889C9.99346 13.1111 10.8889 12.2157 10.8889 11.1111V4C10.8889 2.89543 9.99346 2 8.88889 2H4C2.89543 2 2 2.89543 2 4V11.1111ZM2 20C2 21.1046 2.89543 22 4 22H8.88889C9.99346 22 10.8889 21.1046 10.8889 20V17.3333C10.8889 16.2288 9.99346 15.3333 8.88889 15.3333H4C2.89543 15.3333 2 16.2288 2 17.3333V20ZM13.1111 20C13.1111 21.1046 14.0065 22 15.1111 22H20C21.1046 22 22 21.1046 22 20V12.8889C22 11.7843 21.1046 10.8889 20 10.8889H15.1111C14.0065 10.8889 13.1111 11.7843 13.1111 12.8889V20ZM15.1111 2C14.0065 2 13.1111 2.89543 13.1111 4V6.66667C13.1111 7.77124 14.0065 8.66667 15.1111 8.66667H20C21.1046 8.66667 22 7.77124 22 6.66667V4C22 2.89543 21.1046 2 20 2H15.1111Z"
                    fill="#ECECEF"
                  />
                </svg>
                <div v-if="displayMenuName" class="Nav-Menu-text">
                  Site Operation
                </div>
              </div></router-link
            >
          </li>
          <li>
            <router-link href="" to="/planner2">
              <div
                class="Nav-item"
                :class="{ 'user-info-full': displayMenuName }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_19_14364)">
                    <path
                      d="M18 4H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V4H9V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V4H6C5.20435 4 4.44129 4.31607 3.87868 4.87868C3.31607 5.44129 3 6.20435 3 7V19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22H18C18.7956 22 19.5587 21.6839 20.1213 21.1213C20.6839 20.5587 21 19.7956 21 19V7C21 6.20435 20.6839 5.44129 20.1213 4.87868C19.5587 4.31607 18.7956 4 18 4ZM8 17C7.80222 17 7.60888 16.9414 7.44443 16.8315C7.27998 16.7216 7.15181 16.5654 7.07612 16.3827C7.00043 16.2 6.98063 15.9989 7.01921 15.8049C7.0578 15.6109 7.15304 15.4327 7.29289 15.2929C7.43275 15.153 7.61093 15.0578 7.80491 15.0192C7.99889 14.9806 8.19996 15.0004 8.38268 15.0761C8.56541 15.1518 8.72159 15.28 8.83147 15.4444C8.94135 15.6089 9 15.8022 9 16C9 16.2652 8.89464 16.5196 8.70711 16.7071C8.51957 16.8946 8.26522 17 8 17ZM16 17H12C11.7348 17 11.4804 16.8946 11.2929 16.7071C11.1054 16.5196 11 16.2652 11 16C11 15.7348 11.1054 15.4804 11.2929 15.2929C11.4804 15.1054 11.7348 15 12 15H16C16.2652 15 16.5196 15.1054 16.7071 15.2929C16.8946 15.4804 17 15.7348 17 16C17 16.2652 16.8946 16.5196 16.7071 16.7071C16.5196 16.8946 16.2652 17 16 17ZM19 11H5V7C5 6.73478 5.10536 6.48043 5.29289 6.29289C5.48043 6.10536 5.73478 6 6 6H7V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V6H15V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8C16.2652 8 16.5196 7.89464 16.7071 7.70711C16.8946 7.51957 17 7.26522 17 7V6H18C18.2652 6 18.5196 6.10536 18.7071 6.29289C18.8946 6.48043 19 6.73478 19 7V11Z"
                      fill="#ECECEF"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_19_14364">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div v-if="displayMenuName" class="Nav-Menu-text">
                  Fleet Planner
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <router-link href="" to="/task">
              <div
                class="Nav-item"
                :class="{ 'user-info-full': displayMenuName }"
              ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19.74 7.33018L15.3 2.33018C15.2065 2.22659 15.0924 2.14371 14.9649 2.08688C14.8375 2.03004 14.6995 2.00051 14.56 2.00018H6.56C6.22775 1.99622 5.89797 2.05774 5.5895 2.18124C5.28103 2.30473 4.9999 2.48778 4.76218 2.71993C4.52446 2.95209 4.33479 3.22879 4.20402 3.53425C4.07324 3.8397 4.00392 4.16793 4 4.50018V19.5002C4.00392 19.8324 4.07324 20.1607 4.20402 20.4661C4.33479 20.7716 4.52446 21.0483 4.76218 21.2804C4.9999 21.5126 5.28103 21.6956 5.5895 21.8191C5.89797 21.9426 6.22775 22.0041 6.56 22.0002H17.44C17.7723 22.0041 18.102 21.9426 18.4105 21.8191C18.719 21.6956 19.0001 21.5126 19.2378 21.2804C19.4755 21.0483 19.6652 20.7716 19.796 20.4661C19.9268 20.1607 19.9961 19.8324 20 19.5002V8.00018C19.9994 7.75234 19.9067 7.51358 19.74 7.33018ZM9 12.0002H12C12.2652 12.0002 12.5196 12.1055 12.7071 12.2931C12.8946 12.4806 13 12.735 13 13.0002C13 13.2654 12.8946 13.5198 12.7071 13.7073C12.5196 13.8948 12.2652 14.0002 12 14.0002H9C8.73478 14.0002 8.48043 13.8948 8.29289 13.7073C8.10536 13.5198 8 13.2654 8 13.0002C8 12.735 8.10536 12.4806 8.29289 12.2931C8.48043 12.1055 8.73478 12.0002 9 12.0002ZM15 18.0002H9C8.73478 18.0002 8.48043 17.8948 8.29289 17.7073C8.10536 17.5198 8 17.2654 8 17.0002C8 16.735 8.10536 16.4806 8.29289 16.2931C8.48043 16.1055 8.73478 16.0002 9 16.0002H15C15.2652 16.0002 15.5196 16.1055 15.7071 16.2931C15.8946 16.4806 16 16.735 16 17.0002C16 17.2654 15.8946 17.5198 15.7071 17.7073C15.5196 17.8948 15.2652 18.0002 15 18.0002ZM14.71 8.00018C14.5038 7.97988 14.3139 7.87942 14.1811 7.72043C14.0483 7.56144 13.9833 7.35666 14 7.15018V4.00018L17.74 8.00018H14.71Z"
                    fill="#ECECEF"
                  />
                </svg>
                <div v-if="displayMenuName" class="Nav-Menu-text">
                  Flight Schedule
                </div>
              </div></router-link
            >
          </li>
          <li>
            <router-link href="" to="/mission">
              <div
                class="Nav-item"
                :class="{ 'user-info-full': displayMenuName }"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 11H14.82C14.4 9.84 13.3 9 12 9C10.7 9 9.6 9.84 9.18 11H6C5.67 11 4 10.9 4 9V8C4 6.17 5.54 6 6 6H16.18C16.6 7.16 17.7 8 19 8C19.7956 8 20.5587 7.68393 21.1213 7.12132C21.6839 6.55871 22 5.79565 22 5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2C17.7 2 16.6 2.84 16.18 4H6C4.39 4 2 5.06 2 8V9C2 11.94 4.39 13 6 13H9.18C9.6 14.16 10.7 15 12 15C13.3 15 14.4 14.16 14.82 13H18C18.33 13 20 13.1 20 15V16C20 17.83 18.46 18 18 18H7.82C7.4 16.84 6.3 16 5 16C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22C6.3 22 7.4 21.16 7.82 20H18C19.61 20 22 18.93 22 16V15C22 12.07 19.61 11 18 11ZM19 4C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5C20 5.26522 19.8946 5.51957 19.7071 5.70711C19.5196 5.89464 19.2652 6 19 6C18.7348 6 18.4804 5.89464 18.2929 5.70711C18.1054 5.51957 18 5.26522 18 5C18 4.73478 18.1054 4.48043 18.2929 4.29289C18.4804 4.10536 18.7348 4 19 4ZM5 20C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19C4 18.7348 4.10536 18.4804 4.29289 18.2929C4.48043 18.1054 4.73478 18 5 18C5.26522 18 5.51957 18.1054 5.70711 18.2929C5.89464 18.4804 6 18.7348 6 19C6 19.2652 5.89464 19.5196 5.70711 19.7071C5.51957 19.8946 5.26522 20 5 20Z"
                    fill="#ECECEF"
                  />
                </svg>
                <div v-if="displayMenuName" class="Nav-Menu-text">
                  Mission Planner
                </div>
              </div></router-link
            >
          </li>
          <li>
            <router-link href="" to="/site"
              ><div
                class="Nav-item"
                :class="{ 'user-info-full': displayMenuName }"
              ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.7895 15.0842C18.627 15.0842 19.4302 15.4169 20.0224 16.0091C20.6147 16.6014 20.9474 17.4046 20.9474 18.2421C20.9474 19.0796 20.6147 19.8829 20.0224 20.4751C19.4302 21.0673 18.627 21.4 17.7895 21.4C16.4105 21.4 15.2421 20.5263 14.8105 19.2947H13.5789V17.1895H14.8105C15.2421 15.9579 16.4105 15.0842 17.7895 15.0842ZM17.7895 17.1895C17.5103 17.1895 17.2426 17.3004 17.0452 17.4978C16.8477 17.6952 16.7368 17.9629 16.7368 18.2421C16.7368 18.5213 16.8477 18.789 17.0452 18.9864C17.2426 19.1838 17.5103 19.2947 17.7895 19.2947C18.0686 19.2947 18.3364 19.1838 18.5338 18.9864C18.7312 18.789 18.8421 18.5213 18.8421 18.2421C18.8421 17.9629 18.7312 17.6952 18.5338 17.4978C18.3364 17.3004 18.0686 17.1895 17.7895 17.1895ZM17.7895 7.71579C18.1887 7.71579 18.5716 7.5572 18.8539 7.27491C19.1361 6.99262 19.2947 6.60975 19.2947 6.21053C19.2947 5.37895 18.6211 4.70526 17.7895 4.70526C16.9579 4.70526 16.2842 5.37895 16.2842 6.21053C16.2842 6.60975 16.4428 6.99262 16.7251 7.27491C17.0074 7.5572 17.3903 7.71579 17.7895 7.71579ZM17.7895 2C18.9062 2 19.9771 2.44361 20.7668 3.23323C21.5564 4.02286 22 5.09383 22 6.21053C22 9.35789 17.7895 14.0316 17.7895 14.0316C17.7895 14.0316 13.5789 9.35789 13.5789 6.21053C13.5789 5.09383 14.0226 4.02286 14.8122 3.23323C15.6018 2.44361 16.6728 2 17.7895 2ZM8.13684 17.1895H9.36842V19.2947H8.13684C7.70526 20.5263 6.53684 21.4 5.15789 21.4C4.32037 21.4 3.51715 21.0673 2.92493 20.4751C2.33271 19.8829 2 19.0796 2 18.2421C2 16.8632 2.87368 15.6947 4.10526 15.2632V14.0316H6.21053V15.2632C7.10526 15.5789 7.82105 16.2947 8.13684 17.1895ZM5.15789 17.1895C4.87872 17.1895 4.61098 17.3004 4.41357 17.4978C4.21617 17.6952 4.10526 17.9629 4.10526 18.2421C4.10526 18.5213 4.21617 18.789 4.41357 18.9864C4.61098 19.1838 4.87872 19.2947 5.15789 19.2947C5.43707 19.2947 5.70481 19.1838 5.90222 18.9864C6.09962 18.789 6.21053 18.5213 6.21053 18.2421C6.21053 17.9629 6.09962 17.6952 5.90222 17.4978C5.70481 17.3004 5.43707 17.1895 5.15789 17.1895ZM5.15789 2.45263C5.99542 2.45263 6.79864 2.78534 7.39086 3.37756C7.98308 3.96978 8.31579 4.773 8.31579 5.61053C8.31579 6.98947 7.44211 8.15789 6.21053 8.58947V9.82105H4.10526V8.58947C2.87368 8.15789 2 6.98947 2 5.61053C2 4.773 2.33271 3.96978 2.92493 3.37756C3.51715 2.78534 4.32037 2.45263 5.15789 2.45263ZM5.15789 4.55789C4.87872 4.55789 4.61098 4.6688 4.41357 4.8662C4.21617 5.06361 4.10526 5.33135 4.10526 5.61053C4.10526 5.8897 4.21617 6.15744 4.41357 6.35485C4.61098 6.55226 4.87872 6.66316 5.15789 6.66316C5.43707 6.66316 5.70481 6.55226 5.90222 6.35485C6.09962 6.15744 6.21053 5.8897 6.21053 5.61053C6.21053 5.33135 6.09962 5.06361 5.90222 4.8662C5.70481 4.6688 5.43707 4.55789 5.15789 4.55789ZM10.4211 19.2947V17.1895H12.5263V19.2947H10.4211ZM6.21053 12.9789H4.10526V10.8737H6.21053V12.9789Z"
                    fill="#ECECEF"
                  />
                </svg>
                <div v-if="displayMenuName" class="Nav-Menu-text">
                  Site Configuration
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="2"
          viewBox="0 0 218 2"
          fill="none"
          class="spacer-div1"
        >
          <path
            d="M1 1H217"
            stroke="#f6f6f5"
            class="spacer-div1"
            stroke-linecap="round"
          />
        </svg>
        <div class="fleet-menu">
        </div>
        <div class="spacer2"></div>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="5"
          viewBox="0 0 218 2"
          fill="none"
          class="spacer-div1"
        >
          <path
            d="M1 1H217"
            stroke="#f6f6f5"
            class="spacer-div1"
            stroke-linecap="round"
          />
        </svg>
        <div class="user-info" :class="{ 'user-info-full': displayMenuName }">
          <img class="user-picture" src="@/assets/v3/imgs/person.png" />
          <div v-if="displayMenuName" class="user-data">
            <strong class="user-name-text">{{ userName }}</strong>
            <small class="user-title-text">{{ userTitle }}</small>
          </div>
          <div
            class="more-btn"
            v-if="displayMenuName"
            @click="displayUserMenu = !displayUserMenu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M14.5126 4.25556C14.5127 4.55186 14.4544 4.84528 14.3411 5.11906C14.2278 5.39284 14.0617 5.64163 13.8522 5.85121C13.6428 6.06079 13.3941 6.22707 13.1204 6.34055C12.8467 6.45403 12.5533 6.51248 12.257 6.51258C11.9607 6.51267 11.6673 6.4544 11.3935 6.3411C11.1197 6.2278 10.8709 6.06169 10.6614 5.85224C10.4518 5.64279 10.2855 5.39411 10.172 5.1204C10.0586 4.84669 10.0001 4.55331 10 4.25701C9.99981 3.65861 10.2373 3.08464 10.6603 2.66136C11.0833 2.23809 11.6572 2.00019 12.2556 2C12.854 1.99981 13.4279 2.23734 13.8512 2.66034C14.2745 3.08334 14.5124 3.65716 14.5126 4.25556Z"
                fill="#757C87"
              />
              <path
                d="M12.2565 14.2548C13.5023 14.2548 14.5121 13.2449 14.5121 11.9992C14.5121 10.7535 13.5023 9.74365 12.2565 9.74365C11.0108 9.74365 10.001 10.7535 10.001 11.9992C10.001 13.2449 11.0108 14.2548 12.2565 14.2548Z"
                fill="#757C87"
              />
              <path
                d="M12.2565 21.9999C13.5023 21.9999 14.5121 20.99 14.5121 19.7443C14.5121 18.4986 13.5023 17.4888 12.2565 17.4888C11.0108 17.4888 10.001 18.4986 10.001 19.7443C10.001 20.99 11.0108 21.9999 12.2565 21.9999Z"
                fill="#757C87"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
export default {
  name: "Nav-Bar",
  props:{
    notifyCount:Number,
  },
  data() {
    return {
      time: {
        hour: "00",
        min: "00",
        sec: "00",
      },
      displayMenuName: false,
      organizationName: "AI And Robotics Ventures",
      // userName: "ARV Oper",
      userTitle: "Pilot Operator",
      displayUserMenu: false,
    };
  },

computed: {
  loginState() {
    return this.$store.state.isLogedin;
  },
  webAPI() {
    return this.$store.state.webAPI;
  },
  apiKey() {
    return this.$store.state.apiKey;
  },
  sioServer() {
    return this.$store.state.sioServer;
  },
  customerID() {
    return this.$store.state.customerID;
  },
  userName() {
    return this.$store.state.user;
  },
  customerAssets(){ return this.$store.state.customerAsset;}
},
  mounted() {
    this.Caltime();
    // deepcode ignore VueMissingCleanup: <please specify a reason of ignoring this>
    setInterval(this.Caltime, 200);
  },
  methods: {
    Caltime: function () {
      let currentObj = this;
      var today = new Date();
      currentObj.time.hour = today.getHours().toString().padStart(2, "0");
      currentObj.time.min = today.getMinutes().toString().padStart(2, "0");
      currentObj.time.sec = today.getSeconds().toString().padStart(2, "0");
    },
    async confirmation() {
      // deepcode ignore PromiseNotCaughtGeneral: <please specify a reason of ignoring this>
      await swal
        .fire({
          icon: "warning",
          title: "Please confirm that, Do you want to Sign-out?",
          showCancelButton: true,
          confirmButtonText: `Confirm`,
          target: document.getElementById("app"),
        })

        .then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.confirm = true;
            setTimeout(this.logout_process, 1500);
            // this.$swal.fire("Deleted!", item.missionID, "error");
            swal.fire({
              //position: 'top-end',
              icon: "success",
              title: "Signed out.",
              showConfirmButton: false,
              timer: 1500,
              target: document.getElementById("app"),
            });
          } else {
            history.back();
          }
        })
        .catch((e) => console.error(e));
    },
    logout_process() {
      // sessionStorage.clear();
      let currentObj = this;
      sessionStorage.clear();
      currentObj.$store.commit("setLoginState", false);
      currentObj.$store.commit("setAPIKey", null);
      currentObj.$store.commit("setMntLoginState", false);
      currentObj.$store.commit("setUser", null);
      currentObj.$store.commit("setcustomerID", null);
      // currentObj.$store.commit("setSessionEndURL", '/#/mnt');
      // let sessionEndURL = this.$store.state.sessionEndURL;
      // let sessionEndURL = sessionStorage.getItem("setSessionEndURL");
      // this.$router.push({ path: "home" });
      // window.location.href = "/#/";
      window.location.href = this.$store.state.sessionEndURL;
    },
  },
};
</script>
<style scoped>
/* p.Nav-Menu-text {
  font: bold 12px "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 14px;
  height:75px;
  margin: 0px;
  display: table-cell;
  vertical-align: middle;
  padding: 10px;
  border: 1px solid #f00;
} */
.reset-style,
.reset-style * {
  all: revert;
}
.user-menu-item {
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  width: 200px;
  color: white;
}
.user-menu-item:hover {
  border-radius: 8px;
  background: var(--opacity-primary-50020, rgba(53, 73, 255, 0.2));
  text-decoration: none;
  cursor: pointer;
}
.user-menu {
  position: absolute;
  z-index: 999;
  bottom: 10px;
  left: 240px;
  display: flex;
  width: 216px;
  padding: 8px;
  align-items: flex-start;
  gap: 16px;
  border-radius: 14px;
  background: var(--opacity-gray-secondary-80020, rgb(0, 0, 0));
}
.Nav-Menu-text {
  flex: 1 0 0;
  color: var(--gray-primary-700, #5b626f);

  /* ENG/Subtitle2 */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px; /* 157.143% */
  text-align: start;
  vertical-align: middle;

  /* height: 48px; */
  /* padding: auto; */
}
.clock {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 80px;
  color: white;
  z-index: 999;
  font: 1.2em sans-serif;
  text-align: center;
  margin-bottom: 2rem;
  /* transform: translate(0%, -100%); */
}

.slide-bar {
  transition: width 300ms;
  width: 80px;
  position: fixed;
  left: 0;
  top: 0;
  /* padding-top: 1rem; */
  height: 100%;
  /* background: var(--main-color); */
  background: var(--opacity-gray-secondary-90090, rgba(13, 13, 13, 0.9));
  backdrop-filter: blur(25px);

  z-index: 100;
  /* text-align: center; */
}
.slide-bar-full {
  width: 248px !important;
}
.slide-bar-menu {
  margin-top: 2rem;
}

/* .slide-bar-brand span {
  display: inline-block;
  transition: display 300ms;
  margin-left: 1rem;
  margin-top: 2rem;
}
.slide-bar-brand span {
  display: inline-block;
  transition: display 300ms;
  margin-left: 1rem;
  margin-top: 2rem;
} */
/* .slide-bar-brand {
  height: 90px;
  padding-left: 1rem 0rem 1rem 2rem;
  color: #fff;
  padding-left: 1rem;
  transition: display 300ms;
}
.slide-bar-brand span {
  display: inline-block;
  transition: display 300ms;
  margin-left: 1rem;
  margin-top: 2rem;
}*/
/* //////////////////////////////////// */
/* .slide-bar-menu li {
  width: 100%;
  margin-bottom: 1.7rem;
  padding-left: 1rem;
} */
/* .slide-bar-menu a {
  transition: padding 300ms;
  padding-top: 1rem;pointer
  display: block;
  color: #fff;
  font-size: 1.1rem;
} */
a.router-link-active div {
  text-decoration: none;
  /* background: #fff;
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: var(--main-color);*/
  /* border-radius: 30px 0px 0px 30px;  */
  /* border-color: red; */
  /* background: var(--opacity-blue-primary-50020, rgba(53, 73, 255, 0.2)); */
  /* cursor: pointer; */
  /* color: var(--primary-400, #6778ff); */
}

a.router-link-active {
  /* color: aqua; */
  text-decoration: none;
}

a.router-link-exact-active div:first-child {
  /* color: #42b983;
  background: #fff;
  padding-top: 1rem;
  padding-left: 1rem;
  padding-bottom: 1rem;
  color: var(--main-color);
  border-radius: 30px 0px 0px 30px;

  backdrop-filter: blur(10px); */
  background: var(--opacity-blue-primary-50020, rgba(53, 73, 255, 0.2));
  /* cursor: pointer; */
  color: var(--primary-400, #6778ff);
  text-decoration: none;
}
a:hover {
  text-decoration: none;
}

/* .slide-bar-menu a span:first-child {
  font-size: 2rem;
  padding-right: 1rem;
} */

/* 
#nav-toggle:checked + .slide-bar {
  width: 80px;
}
#nav-toggle:checked + .slide-bar .slide-bar-brand,
#nav-toggle:checked + .slide-bar li {
  padding-left: 1rem;
  text-align: center;
}

#nav-toggle:checked + .slide-bar li a {
  padding-left: 0rem;
}

#nav-toggle:checked + .slide-bar .slide-bar-brand h2 span:last-child,
#nav-toggle:checked + .slide-bar li a span:last-child {
  display: none;
} */

@media only screen and (max-height: 780px) {
  .clock {
    display: none;
  }
}
.more-btn {
  display: flex;
  align-items: center;
  align-self: stretch;
}
.more-btn :hover {
  cursor: pointer;
}
.Nav-container {
  display: inline-flex;
  height: 100vh;
  /* width: 88px; */
  padding: 24px 16px 33px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 50px;
  flex-shrink: 0;
  /* background: var(--opacity-gray-secondary-90090, rgba(13, 13, 13, 0.9)); */
  backdrop-filter: blur(25px);
  width: 80px;
  transition-property: width;
  transition-duration: 0.5s;
}

.Nav-Org-layout {
  display: flex;
  height: 48px;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
  align-self: stretch;
}
.Nav-Org-logo {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden !important;
}
.Nav-Org-text {
  display: flex;
  width: 210px;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
  align-self: stretch;
  color: var(--gray-primary-50, #ececef);

  /* ENG/Headline [H6] */
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 155.556% */
}
.Nav-Organize-Info-item {
  display: flex;
  /* width: 48px; */
  height: 48px;
  padding: auto;
  text-align: center;

  /* padding: 0px 102px 0px 0px; */
  align-items: center;
  /* gap: 8px; */
  flex-shrink: 0;
  max-width: 48px;
  max-height: 48px;
  border-radius: 48px;
  background: #ececef;
  /* overflow: hidden; */
  position: relative;
}
.Nav-Organize-Info-item-full {
  display: flex;
  width: auto;
  height: 48px;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
  align-self: stretch;
}

.org-logo {
  position: absolute;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  /* width: 48px; */
  /* height: 48px; */
  /* transform: rotate(90deg); */
  /* flex-shrink: 0; */
  /* border-radius: 48px; */
  /* background: #ececef; */
  /* background: url(<path-to-image>), lightgray 50% / cover no-repeat; */
  /* border-radius: 48px; */
  /* background: url('../../assets/v3/imgs/Org_logo.png'), lightgray 50% / cover no-repeat; */
}

.org-name-text {
  display: flex;
  /* width: 160px; */
  flex-direction: column;
  flex-shrink: 0;
  color: var(--gray-primary-50, #ececef);

  /* ENG/Headline [H6] */
  font-size: 18px;
  font-family: Roboto;
  font-weight: 700;
  line-height: 28px;
}

.Nav-item {
  display: flex;
  /* width: 216px; */
  height: 40px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  margin-bottom: 16px;
}

.Nav-sub-item:hover,
.Nav-item:hover {
  background: var(--opacity-blue-primary-50020, rgba(53, 73, 255, 0.2));
  cursor: pointer;
  color: var(--primary-400, #6778ff);
}

.Nav-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.Nav-text {
  display: flex;
  flex-direction: column;
  flex: 1 0 0;

  /* ENG/Subtitle2 */
  font-size: 14px;
  font-family: Roboto;
  font-weight: 700;
  line-height: 22px;
}

.Nav-Bar {
  /* display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  display: flex;
  
  flex-direction: column;
  justify-content: space-between;
  flex: 1 0 0; */
  /* width: 56px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  align-self: stretch;
}

.Nav-specer {
  width: 100% !important;
  display: block;
  height: 1px;
  background: var(--gray-primary-600, #757c87);
  border-color: #282827;
}

.Nav-sub-nav {
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  border-radius: 10px;
  /* background: var(--opacity-gray-primary-80020, rgba(62, 71, 84, 0.2)); */
}

.Nav-sub-item {
  display: flex;
  /* width: 192px; */
  /* max-width: 100%; */
  /* height: 48px; */
  padding: 16px;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  color: var(--gray-primary-600, #757c87);
  margin-bottom: 5px;

  /* ENG/Subtitle2 */
  font-size: 14px;
  font-family: Roboto;
  font-weight: 700;
  line-height: 22px;
}

.spacer2 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
}

.user-info {
  display: flex;
  /* width: 216px; */
  align-items: center;
  gap: 8px;
}
.user-info-full {
  width: 216px;
}
.user-picture {
  width: 48px;
  height: 48px;
  /* transform: rotate(90deg); */
  flex-shrink: 0;
  border-radius: 48px;
  /* background: url(<path-to-image>),
    lightgray 391900767148670500px 8304296894657687px / -816459931559730300% -544374660573338100%
      no-repeat; */
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.user-data {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 130px;
}

.user-name-text {
  display: flex;
  /* width: 160px; */
  height: 22px;
  flex-direction: column;
  color: #ececef;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 600;
  line-height: 22px;
}

.user-title-text {
  display: flex;
  /* width: 160px; */
  height: 18px;
  flex-direction: column;
  color: #757c87;
  font-size: 12px;
  font-family: Roboto;
  line-height: 18px;
}
.spacer-div1 {
  stroke-width: 1px;
  stroke: var(--gray-secondary-400, #282827);
}
.fleet-menu {
  border-radius: 10px;
  background: var(--opacity-gray-primary-80020, rgba(62, 71, 84, 0.2));
  display: flex;
  padding: 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}
</style>
